import React from "react";
import { motion } from "framer-motion";
import ProjectCard from "./ProjectCards";
import ecommerce from "../../Assets/Projects/commerce.png";
import saas from "../../Assets/Projects/saas.png";
import zoom from "../../Assets/Projects/zoom.png";

function Projects() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.2 
      } 
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.6 } }
  };

  const projects = [
    {
      title: "All-in-One Image Transformation Toolkit",
      description: "Developed a full-stack image transformation platform using React.js, MongoDB, and Cloudinary. Implemented user authentication, payment integration, and secure APIs for advanced image editing features.",
      imgPath: saas,
      ghLink: "https://github.com/vijay5599/imaginify.git",
      demoLink: "https://imaginify-swart.vercel.app/",
      className: "md:col-span-2 lg:col-span-8" // Bento effect: wider card
    },
    {
      title: "Real-Time Video Conferencing App",
      description: "Built a Zoom-like video conferencing platform using Next.js, TypeScript, and getStream. Features include authentication (Clerk), real-time meetings, and recording.",
      imgPath: zoom,
      ghLink: "https://github.com/vijay5599/zoom",
      demoLink: "https://zoom-liard-gamma.vercel.app/",
      className: "md:col-span-1 lg:col-span-4"
    },
    {
      title: "Ecommerce Website",
      description: "Designed and developed a full-fledged E-commerce website utilizing the MERN stack. Features an admin panel for product and order management.",
      imgPath: ecommerce,
      ghLink: "https://github.com/vijay5599/MERN-ecommerce-Frontend.git",
      className: "md:col-span-1 lg:col-span-4"
    },
    {
      title: "Future Project",
      description: "Working on more innovative solutions. Stay tuned!",
      imgPath: zoom, // Placeholder
      ghLink: "#",
      className: "md:col-span-2 lg:col-span-8" // Bento effect: wider card
    }
  ];

  return (
    <section className="relative min-h-screen py-32 bg-dark overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 space-y-4"
        >
          <h1 className="text-4xl md:text-6xl font-bold font-manrope">
            My Recent <span className="text-primary">Works</span>
          </h1>
          <p className="text-neutral-400 text-lg">
            Here are a few projects I've worked on recently.
          </p>
        </motion.div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6"
        >
          {projects.map((project, index) => (
            <motion.div 
              key={index} 
              variants={itemVariants}
              className={project.className}
            >
              <ProjectCard {...project} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Projects;
